import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { labels } from '../../data/labels';
import { getConfiguration } from '../../data/utils/configuration';

function BetslipButtons(props) {
    const betslipContext = useContext(BetslipContext);
    const configuration = getConfiguration();
    function changeButtonState(buttonState) {
    	betslipContext.setPlayButtonState(buttonState);
    }
    
    function purchase() {
    	betslipContext.purchase();
    }
    
    function resetCart() {
    	changeButtonState('play');
    }
    
    function reserveTicket() {
    	betslipContext.reserveTicket();
    }
    
    const playButtonState = betslipContext.getPlayButtonState();
    const cartMessage = betslipContext.getCartMessage();
    
    return (
        <>
            {cartMessage != null &&
                <div className={"betslip-message " + cartMessage.type}>
                    <div> {cartMessage.message} </div>
                </div>
            }
            <div className="bottoni-schedina">
                {(playButtonState === 'play' || playButtonState === 'again') &&
                    <>
                        <button id="btn-prenota" onClick={() => reserveTicket() } className="bottone bg-arancio bianco maiuscolo">{labels['betslip.button.reserve_ticket']}</button>
                        <button id="btn-gioca" onClick={() => changeButtonState('confirm')} className="bottone bg-verde bianco maiuscolo">{playButtonState === 'play'? labels['betslip.button.buy'] : labels['betslip.button.again']}</button>
                    </>
                }
                {playButtonState === 'confirm' &&
                    <>
                        <button onClick={() => resetCart() } className="bottone bg-arancio bianco maiuscolo">{labels['betslip.go_back']}</button>
                        <button onClick={() => purchase()} className="bottone bg-blu bianco maiuscolo">{labels['betslip.ok']}</button>
                    </>
                }
            </div>
           { configuration.turn?.en && window.turnstile && <div style={{'display' : 'flex', 'justifyContent' : 'center'}} id="turnstile-container"></div> }
        </>
    );
}

export default BetslipButtons;